var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-viewer preview-wps-edit"},[(_vm.link)?_c('iframe',{ref:"wps_edit_frame",attrs:{"src":_vm.link,"id":"wps_edit_frame","name":"wps_edit_frame"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }